import { Option, operacaoTipoOptions } from 'common/genericOptions';
import { OperacaoTipo } from 'common/genericTypes';

const tiposGeradosAutomaticamentePelaPlataforma: Array<string> = [OperacaoTipo.CompraVendaCompromissadaRetorno];

export const opcoesDeTipoDeMovimentacaoCadastraveis: Array<Option> = operacaoTipoOptions.filter(
  (opcao) => !tiposGeradosAutomaticamentePelaPlataforma.includes(opcao.value)
);

export const opcoesDeTipoDeMovimentacaoDoCustodiante: Array<Option> = opcoesDeTipoDeMovimentacaoCadastraveis.filter(
  (opcao) =>
    opcao.value !== OperacaoTipo.CompraVenda &&
    opcao.value !== OperacaoTipo.Transferencia &&
    opcao.value !== OperacaoTipo.TransferenciaInterop &&
    opcao.value !== OperacaoTipo.TransferenciaTitularidade &&
    opcao.value !== OperacaoTipo.TransferenciaCustodia &&
    opcao.value !== OperacaoTipo.CancelamentoQuantidades
);

export const opcoesDeTipoDeMovimentacaoDoUsuarioOperacoes: Array<Option> =
  opcoesDeTipoDeMovimentacaoCadastraveis.filter(
    (opcao) =>
      opcao.value !== OperacaoTipo.CompraVenda &&
      opcao.value !== OperacaoTipo.Compra &&
      opcao.value !== OperacaoTipo.Venda &&
      opcao.value !== OperacaoTipo.CompraVendaCompromissada &&
      opcao.value !== OperacaoTipo.OfertaPrimaria &&
      opcao.value !== OperacaoTipo.TransferenciaTitularidade &&
      opcao.value !== OperacaoTipo.TransferenciaCustodia &&
      opcao.value !== OperacaoTipo.TransferenciaUnificada &&
      opcao.value !== OperacaoTipo.SaidaInteroperabilidade
  );
